import { ExternalLink, Modal } from '@common/components';
import React from 'react';

export function activeWorkersInfoModal(workforceGroupId: string) {
  const externalUrl = `/works/admin/groups/${workforceGroupId}/staff`;
  Modal.confirm({
    title: 'Active Workers must be moved first.',
    content: (
      <>
        You can&apos;t archive a group with{' '}
        <ExternalLink url={externalUrl}>active workers</ExternalLink>. Please
        deactivate them or move to another group.
      </>
    ),
    okText: 'OK',
    hideCancelButton: true,
  });
}

export function confirmArchiving(onConfirm: () => void) {
  Modal.confirm({
    danger: true,
    title: 'Permanently archive this Group?',
    content:
      'This is a permanent action and cannot be undone. Archived groups cannot be restored.',
    okText: 'Permanently Archive',
    cancelText: 'Cancel',
    onOk: onConfirm,
  });
}
